module.exports = __webpack_public_path__ + "static/media/wn_20.11e20ea9.jpg";